import type { ReactNode } from "react";

/**
 * Props for {@link Eyebrow}.
 */
export interface EyebrowProps {
  /** Inline content displayed in the eyebrow (typically a short label). */
  children: ReactNode;
  /** Optional Tailwind classes appended to the default styling. */
  className?: string;
}

/**
 * Tiny uppercase label used to caption a section or field (e.g. `Tonalité`,
 * `Qualité`, `Pistes piano`). Pure presentation, no behaviour.
 *
 * Styling: 11px, medium weight, uppercase, wide letter-spacing, muted text.
 */
export function Eyebrow({ children, className }: EyebrowProps) {
  const base =
    "text-[11px] font-medium uppercase tracking-wider text-[color:var(--color-text-muted)] shrink-0";
  const classes = className ? `${base} ${className}` : base;

  return <span className={classes}>{children}</span>;
}
